import React from 'react';
import { cn } from '@/lib/utils';
import { useEnvironment } from '@/contexts/EnvironmentContext';

const EnvironmentBadge: React.FC = () => {
  const { environment, toggle } = useEnvironment();
  const isProduction = environment === 'production';

  return (
    <button
      type="button"
      onClick={toggle}
      className={cn(
        'flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-mono font-medium uppercase tracking-wide transition-colors',
        isProduction
          ? 'border-accent/40 bg-accent/10 text-accent-text'
          : 'border-border bg-surface-raised text-muted-foreground'
      )}
      aria-label={`Switch to ${isProduction ? 'sandbox' : 'production'} environment`}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', isProduction ? 'bg-accent-text' : 'bg-muted-foreground')} />
      {environment}
    </button>
  );
};

export default EnvironmentBadge;
